export const DECISIONS = {
  ACTIVE: 'true',
  INACTIVE: 'false',
  VALID: 'true',
  INVALID: 'false',
} as const
